export class DashboardRoutingRouteNames {
    public static readonly UserDashboard = 'user-dashboard';
    public static readonly Dashboard = 'dashboard';
    public static readonly Documents = 'documents';
    public static readonly Personalize = 'personalize';
    public static readonly Appointment = 'appointment';
    public static readonly Animals = 'animals';
    public static readonly Patient = 'patient';
    public static readonly Veterinarians = 'veterinarians';
    public static readonly Insurance = 'insurance';
    public static readonly PetHealthPlan = 'pet-health-plan';
    public static readonly Account = 'account';
    public static readonly Help = 'help';
    public static readonly Merge = 'merge';
    public static readonly Finances = 'finances';
    public static readonly Medication = 'medication';
    public static readonly SelfCheckIn = 'self-check-in';
    public static readonly GoodToKnow = 'good-to-know';
    public static readonly Emergency = 'emergency';
    public static readonly Assignments = 'assignments';
    public static readonly Logout = 'logout';
    public static readonly AccessibilityFeedback = 'accessibility-feedback';
}
